export { default } from './ProfileContent';
export { default as template } from './profile-content.tpl';
